import { render, staticRenderFns } from "./SigepTabInformation.vue?vue&type=template&id=3aa2e026&scoped=true"
import script from "./SigepTabInformation.vue?vue&type=script&lang=js"
export * from "./SigepTabInformation.vue?vue&type=script&lang=js"
import style0 from "./SigepTabInformation.vue?vue&type=style&index=0&id=3aa2e026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2e026",
  null
  
)

export default component.exports